import {useCallback, useEffect} from "react";
import {EMPTY_USER_STORE} from "../_types";
import {useNavigate} from "react-router";
import {useSelector} from "react-redux";
import jwtDecode from "jwt-decode";
import {toast} from "react-toastify";

const TIME_BETWEEN_CHECKS = 2 // en minutes

export const usePeriodicTokenValidation = (request, sendRequest, store) => {

    const navigate = useNavigate();
    const user = useSelector(state => state.userReducer.user);
    const token = user?.token;

    let mounted = true

    const disconnect = useCallback((toastText = "Votre session a expiré. Merci de vous reconnecter.") => {
        localStorage.removeItem('userReducer')
        store.dispatch({type: EMPTY_USER_STORE});
        navigate("/signIn")
        toast.warning(toastText)
    }, [store, navigate])

    useEffect(() => {
        if (!token) {
            navigate("/signIn")
            return;
        }

        const checkToken = () => {
            if (!mounted || !token) return; // éviter les memory leaks

            try {
                jwtDecode(token)
            } catch (err) {
                disconnect();
                return;
            }

            sendRequest({
                id: "checkToken",
                url: "/api/users/validateAuth",
                data: { token },
                headers: {}
            })
        }

        checkToken()
        const interval = setInterval(checkToken, TIME_BETWEEN_CHECKS * 60 * 1000);

        return () =>  {
            mounted = false;
            clearInterval(interval);
        }
    }, [token, sendRequest, disconnect])

    useEffect(() => {
        const response = request["checkToken"];
        if (!response) return;

        try {
            if (response.status < 200 || response.status >= 300) {
                if (response.status === 406)
                    disconnect("Votre session a expiré. Merci de vous reconnecter.");
                else if (response.status === 403)
                    disconnect("Vous ne pouvez être connecté que sur un seul appareil à la fois avec ce compte.");
            }
        } catch (err) {
            disconnect();
        }
    }, [request, navigate, token, disconnect]);
}

